import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const Runes: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 32 32"
			fill="none"
			className={props.className}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<g clipPath="url(#clip0_2115_729)">
				<path d="M30.72 1.28H1.28V30.72H30.72V1.28Z" stroke="white" strokeWidth="2.56" />
				<path d="M22.86 9.14H9.14V22.86H22.86V9.14Z" fill="white" />
			</g>
			<defs>
				<clipPath id="clip0_2115_729">
					<rect width="32" height="32" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}

export default Runes
